<template>
	<div class="img-wrap">
        <h1>{{title}}</h1>
        <div  v-show='title=="截图信息"' class="img-content">
            <span v-for="(item,index) in detailInfo.order_images" :key="index">
                <el-image :src="item" :preview-src-list="detailInfo.order_images" @click.stop="handleClickItem"></el-image>
            </span>
        </div>
        
		<div  v-show='title=="补充信息"' class="supply-co">
			<p>{{detailInfo.order_supplement}}</p>
			<div class="img-supply">
				<span v-for="(obj,idx) in detailInfo.order_supplement_img" :key="idx">
					<el-image :src="obj" :preview-src-list="detailInfo.order_supplement_img" @click.stop="handleClickItem"></el-image>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:"截图信息"
        },
        
        detailInfo:{
            type:Object,
            default:()=>{}
        }
    },
    data() {
    	return {
			imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl")
		};
    },
    
    watch:{
        detailInfo:{
            handler(val){
                if(val.order_supplement_img && val.order_supplement_img.length){
                    val.order_supplement_img.forEach((item,index)=>{
                        if(!item.includes("http") && !item.includes("https")){
                            val.order_supplement_img[index] = this.imgUrl + val.order_supplement_img[index];
                        }
                    })
                }
            },
            immediate: true,
            deep: true
        }
    },
    
    beforeUpdate(){
        if(this.detailInfo.order_images && this.detailInfo.order_images.length){
            this.detailInfo.order_images.forEach((item,index)=>{
                if(!item.includes("http") && !item.includes("https")){
                    this.detailInfo.order_images[index] = this.imgUrl + this.detailInfo.order_images[index];
                }
            })
        }
    },
  
    methods:{
        handleClickItem(){
            this.$nextTick(()=>{
                // 获取遮罩层dom
                let domImageMask = document.querySelector(".el-image-viewer__mask");
                if (!domImageMask) {
                  return;
                }
                domImageMask.addEventListener("click", () => {
                    // 点击遮罩层时调用关闭按钮的 click 事件
                    document.querySelector(".el-image-viewer__close").click();
                });
            })
        }
    },
};
</script>

<style>
    .el-image-viewer__close{
        color: #fff;
    }
</style>

<style lang="scss" scoped>
	.img-wrap{
        margin-top: 20px;
        h1{
            font-size: 20px;
            @include font-style;
            color: #000000;
        }
        .img-content{
            // width: 540px;
            padding: 30px 24px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
            margin-top: 30px;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			span{
				width: 150px;
				height: 150px;
				margin-right: 20px;
				margin-bottom: 15px;
				.el-image{
					width: 150px;
					height: 150px;
				}
			}

            span:nth-child(3n){
                margin-right: 0;
            }
        }
		.supply-co{
			margin-top: 30px;
			padding: 30px 24px;
			box-sizing: border-box;
			background: #FFFFFF;
			box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
			p{
				margin-bottom: 20px;
				font-size: 16px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #000;
			}
			.img-supply{
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				span{
					width: 150px;
					height: 150px;
					margin-right: 20px;
					margin-bottom: 15px;
					.el-image{
						width: 150px;
						height: 150px;
					}
				}
				
				span:nth-child(3n){
				    margin-right: 0;
				}
			}
		}
    }
	
</style>